import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {CompanyMember, CompanyMemberEx} from "../types/domain/companyMember";

export type PostCompanyMemberBodyType = Omit<CompanyMember, "companyId">;
export type PatchCompanyMemberBodyType = Partial<Omit<CompanyMember, "companyId" | "userId">>;

export const getCompanyMembers = async (companyId: string): Promise<CompanyMemberEx[]> =>
    await apiClient
        .get<CompanyMemberEx[]>(`/companies/${companyId}/members`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const createCompanyMember = async (companyId: string, body: PostCompanyMemberBodyType): Promise<CompanyMember> =>
    await apiClient
        .post<CompanyMember>(`/companies/${companyId}/members`, body)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const patchCompanyMember = async (
    companyId: string,
    userId: string,
    body: PatchCompanyMemberBodyType,
): Promise<CompanyMember> =>
    await apiClient
        .patch<CompanyMember>(`/companies/${companyId}/members/${userId}`, body)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const resetPasswordCompanyMember = async (companyId: string, userId: string): Promise<void> =>
    await apiClient
        .post(`/companies/${companyId}/members/${userId}/resetPassword`)
        .then(() => undefined)
        .catch(handleAxiosError);

export const deleteCompanyMember = async (companyId: string, userId: string) =>
    await apiClient.delete(`/companies/${companyId}/members/${userId}`).catch(handleAxiosError);
